import { EVENTS, subscribe } from 'util.pubsub'

class Gallery extends HTMLElement {
  constructor() {
    super()
    this.unsubscribe = null
  }

  get sectionId() {
    return this.getAttribute('section-id')
  }

  connectedCallback() {
    this.thumnailSlider = this.querySelector(':scope > [data-gallery-thumbnails] component-slider')
    this.slider = this.querySelector(':scope > [data-gallery-slider] component-slider')
    this.unsubscribe = subscribe(EVENTS.sliderUpdate, this.handleSliderUpdate.bind(this))
  }

  handleSliderUpdate(event) {
    console.log('sliderUpdate', event.detail)
    if (event.detail.sliderElement === this.slider) {
      console.log('=== gallery thumbnail scrollToIndex', event.detail.activeIndex)
      this.thumnailSlider.scrollToIndex(event.detail.activeIndex, true)
    }
    if (event.detail.sliderElement === this.thumnailSlider) {
      console.log('=== gallery slider scrollToIndex', event.detail.activeIndex)
      this.slider.scrollToIndex(event.detail.activeIndex, true)
    }
  }

}

customElements.define('component-gallery', Gallery) 